import Link from 'next/link';

import {formatRecentDate} from 'utils/DateTime';

import {ArrowLeft} from 'components/v3/icons/Arrows';

export const ExpenseCard = ({amount, date}: {amount: string; date: Date}) => {
  return (
    <Link href="/apps/payments">
      <div className={'flex justify-between w-full'}>
        <div>
          <span className={'text-[14px] font-bold'}>${amount}</span>
        </div>
        <div className={'flex gap-2 my-auto'}>
          <span className={'text-sm text-nr-darker-text'}>
            {formatRecentDate(date)}
          </span>
          <div className={' stroke-[#9F9F9F] opacity-75 mt-[-2px]'}>
            <ArrowLeft />
          </div>
        </div>
      </div>
    </Link>
  );
};
